// WS #2304782. Kept apart from ./http so a hook can listen without importing axios.
export const TOKEN_REFRESHED = 'auth:token-refreshed'
